import requestApi from "@/utils/requestApi";
import { mapState } from "vuex";

export default {
  data() {
    return {
      scLink: process.env.VUE_APP_APP,
      loading: false,
      tableData: [],
    };
  },
  computed: {
    ...mapState("cart", ["vipInfo"]),
    visibleSync: {
      get() {
        const { visible, goods } = this.vipInfo;
        if (visible) {
          this.loading = true;

          requestApi
            .post("sctrading/goods/selGoodsVipPriceByList", {
              goodsId: goods.skuId,
            })
            .then((res) => {
              this.tableData = res.data;
            })
            .finally(() => {
              this.loading = false;
            });
        }
        return this.vipInfo.visible;
      },
      set(visible) {
        this.$store.commit("cart/saveVipInfo", {
          visible,
        });
      },
    },
  },
  methods: {},
};
